import _ from 'lodash';
export default class Test extends Object {
    constructor(test) {
        super();
        if (test) {
            _(this).keys().each(key => {
                if (test.hasOwnProperty(key)) {
                    this[key] = test[key];
                }
            });
            this.areas = _.map(this.areas, (area, i) => {
                area.index = i + 1;
                return area;
            });
        }

    }

    id = null;
    url = null;
    areas = [];
    preview_areas = null;
    image = null;
    image_url = null;
    images = null;
    age_ranges_id = null;
    language_countries_id = null;
    own_testers = false;
    predefined_panel_id = null;
    package_id = null;
    created_at = null;
    updated_at = null;
    status = null;
    hash = null;
    progress = null;
    imageToUpload = null;
    eligibility_requirement_attributes = [];
    testers_cnt = null;
}

